"use client";

import { useNavigationState } from "../providers";

/**
 * Convenience hook that exposes the unified compact layout state.
 * Both menu and side content share the same breakpoint (1000px),
 * so a single boolean captures the layout mode.
 *
 * Must be called inside NavigationStateProvider.
 */
export const useCompactLayout = () => {
  const { sideContentVariant } = useNavigationState();

  return {
    /**
     * `true` when the viewport is below the compact breakpoint (1000px).
     * In compact mode the menu becomes an overlay and the side content
     * renders as a portal instead of a sidebar panel.
     */
    isCompact: sideContentVariant === "compact",
  };
};
